import { jsx } from '@emotion/react';
import RecentColor from './RecentColor';

const RecentColorsList = ({recentlyViewed, ...itemProps}) => (
  recentlyViewed.map(recentView => (
    <RecentColor
      {...itemProps}
      recentView={recentView}
      key={recentView.uuid}
    />
  ))
)

export default RecentColorsList;
